/* eslint-disable prefer-rest-params */
import admin from './admin.api';
import transporter from './transporter.api';
import shipper from './shipper.api';
import report from './report.api';

export default {
  auth: {
    forgotPassword({ email }) {
      return {
        method: 'post',
        url: 'auth/recoverPassword',
        data: { email },
      };
    },
    resetPassword({ password, token }) {
      return {
        method: 'post',
        url: 'auth/resetPassword',
        data: { password, token },
      };
    },
  },
  city: {
    search({ query }) {
      return {
        method: 'get',
        url: 'city/search',
        params: {
          query,
        },
      };
    },
    getBasic() {
      return {
        method: 'get',
        url: 'city/basic',
      };
    },
    getAll() {
      return {
        method: 'get',
        url: 'city',
      };
    },
    update({ id, subscriptionPrice, rfqSentPrice, bookingReceivedPrice, commissionRate }) {
      return {
        method: 'put',
        url: `city/${id}`,
        data: {
          subscriptionPrice,
          rfqSentPrice,
          bookingReceivedPrice,
          commissionRate,
        },
      };
    },
    create({ name, country }) {
      return {
        method: 'post',
        url: 'city',
        data: {
          name,
          country,
        },
      };
    },
  },
  quotes: {
    rfq(id) {
      return {
        method: 'get',
        url: `shipper/quoteRequest/${id}`,
      };
    },
    createQuoteRequest(data) {
      return {
        method: 'post',
        url: 'shipper/quoteRequest',
        data,
      };
    },
    updateQuoteRequest(id, data) {
      return {
        method: 'put',
        url: `transporter/quoteRequest/${id}`,
        data,
      };
    },
    getQuoteTemplate() {
      return {
        method: 'get',
        url: 'transporter/quote_template',
      };
    },
    updateQuoteTemplate({ content }) {
      return {
        method: 'put',
        url: 'transporter/quote_template',
        data: {
          content,
        },
      };
    },
    /**
     * @param {object} data
     * @param {string} data.requestId
     * @param {{ payment: string, price: number }[]} data.costs
     * @param {number} data.subTotal
     * @param {number} data.addGst
     * @param {number} data.totalAud
     * @param {string[]} data.tradingTerms
     * @param {string} data.quoteValidity
     * @param {string[]} [data.conditionFiles]
     * @param {string[]} [data.attachFiles]
     * @param {string} data.note
     */
    sendQuoteResponse(data) {
      return {
        method: 'POST',
        url: 'transporter/quote-response',
        data,
      };
    },
    getResponseLogs(responseId) {
      return {
        method: 'GET',
        url: `quoteResponse/${responseId}/logs`,
      };
    },
  },
  setting: {
    get() {
      return {
        method: 'get',
        url: 'users/me/setting',
      };
    },
    update({
      isNotificationQuoteReceived,
      isNotificationMessageReceived,
      isNotificationRfqDeleted,
      isReceivingCopyOfRfq,
      isReceivingCopyOfQuote,
      isReceivingNews,
      isReceivingPromotions,
    }) {
      return {
        method: 'put',
        url: 'users/me/setting',
        data: {
          isNotificationQuoteReceived,
          isNotificationMessageReceived,
          isNotificationRfqDeleted,
          isReceivingCopyOfRfq,
          isReceivingCopyOfQuote,
          isReceivingNews,
          isReceivingPromotions,
        },
      };
    },
  },
  me: {
    get() {
      return {
        method: 'get',
        url: 'users/me',
      };
    },
    updateVerifiedPhone(phoneNumber) {
      return {
        method: 'PUT',
        url: 'users/me/verified-phone',
        data: {
          phoneNumber,
        },
      };
    },
    verify({ type, code }) {
      return {
        method: 'PUT',
        url: 'users/me/verify',
        data: {
          type,
          code: code.replace(/ /g, ''),
        },
      };
    },
    resendCode(type) {
      return {
        method: 'POST',
        url: `users/me/verify/resend?type=${type}`,
      };
    },
    changePassword(data) {
      return {
        method: 'POST',
        url: 'users/me/password',
        data,
      };
    },
  },
  profile: {
    get() {
      return {
        method: 'get',
        url: 'users/me/profile',
      };
    },
    updateShipperProfile(data) {
      return {
        method: 'PUT',
        url: 'users/me/profile',
        data,
      };
    },
    updateShipperCompanyImage({ imageUrl }) {
      return {
        method: 'PUT',
        url: 'users/me/profile/photo',
        data: {
          companyLogo: imageUrl,
        },
      };
    },
  },
  serviceOption: {
    get() {
      return {
        method: 'get',
        url: 'transporter/service_options',
      };
    },
    update({ truckCount, truckTypes, containerTypes, deliveryTypes, terminalIds }) {
      return {
        method: 'put',
        url: 'transporter/service_options',
        data: {
          truckCount,
          truckTypes,
          containerTypes,
          deliveryTypes,
          terminalIds,
        },
      };
    },
  },
  invoice: {
    getInvoices({ params }) {
      return {
        method: 'GET',
        url: 'transporter/invoices',
        params,
      };
    },
  },
  upload: {
    image(contentType) {
      return {
        url: 'upload/image/',
        method: 'get',
        params: {
          contentType,
        },
      };
    },
    document(contentType) {
      return {
        url: 'upload/document/',
        method: 'GET',
        params: {
          contentType,
        },
      };
    },
  },
  file: {
    size(filename) {
      return {
        url: 'file/size',
        method: 'get',
        params: {
          filename,
        },
      };
    },
  },
  admin,
  shipper,
  transporter,
  report,
};
